<div *ngIf="data" [ngClass]="customClass">
  <div [attr.data-value]="data">
    <span p500UITooltip [tooltipData]="data" [longContent]="true">{{
      data.length > length ? (data | slice: 0:length) + '...' : data
    }}</span>
  </div>
</div>
<div *ngIf="!data">
  <gtd-ui-field-empty-component></gtd-ui-field-empty-component>
</div>
